import { MutableRefObject } from "react";
import * as React from "react";

import { ReactElement, ReactNode } from "react";

import "./FlexRow_style.css";

type Props = Readonly<{
    children: ReactNode;
    alignment?: "start" | "center" | "end";
    width?: "full" | "half" | "quarter" | "auto" | string | number;
    style?: React.CSSProperties | undefined;
    className?: string;
    onClick?: (event?: React.MouseEvent) => void;
    onBlur?: () => void;
    gap?: 4 | 8 | 12 | 16;
    wrap?: boolean;
    forwardRef?: MutableRefObject<any>;
}>;

export default function FlexRow({
    children,
    alignment = "start",
    width,
    style,
    className,
    onClick,
    onBlur,
    gap,
    wrap,
    forwardRef,
}: Props): ReactElement {
    const widthClass =
        width === "full" || width === undefined
            ? "full-width"
            : width === "half"
            ? "half-width"
            : width === "quarter"
            ? "quarter-width"
            : width === "auto"
            ? "auto-width"
            : null;

    return (
        <div
            ref={forwardRef}
            className={`flex-row${
                alignment === "end"
                    ? " flex-end"
                    : alignment === "center"
                    ? " flex-center"
                    : ""
            }${gap != undefined ? ` gap-${gap}` : ``}${
                wrap === true ? ` wrap` : ``
            }${widthClass === null ? `` : ` ${widthClass}`}${
                className != null ? ` ${className}` : ""
            }`}
            style={
                style == null
                    ? width == null ||
                      width === "full" ||
                      width === "half" ||
                      width === "quarter"
                        ? undefined
                        : { width: width }
                    : width == null ||
                      width === "full" ||
                      width === "half" ||
                      width === "quarter"
                    ? style
                    : { ...style, width: width }
            }
            onClick={onClick}
            onBlur={onBlur}
        >
            {children}
        </div>
    );
}
